// FIX: Sleek's fast-click shim (theme.js) calls preventDefault() on touchend for any
// target outside its allow-list (a, button, label, select, summary, [role=button]) and
// returns WITHOUT replaying the click — so form fields never focus and non-semantic
// controls never fire. Suppress that handler for those cases only.
// Remove when the theme vendor widens their allow-list.
document.addEventListener('touchend', function (e) {
  // Never interfere with sliders: Swiper needs its own touchend to complete a swipe.
  if (e.target.closest('.swiper, .swiper-slide, .swiper-wrapper')) return;

  if (e.target.closest(
    'input, textarea, select, [contenteditable],' +
    '.OfferlyModal .close'
  )) {
    e.stopImmediatePropagation();
  }
}, true);

